/* @ngInject */
export default function ProfileService($sails, appConfig, $q, $log) {
  const service = this;

  service.getProfileData = getProfileData;
  service.getTwoFactor = getTwoFactor;
  service.resetPassword = resetPassword;
  service.saveProfile = saveProfile;
  service.resetPassword = resetPassword;
  service.updatePassword = updatePassword;
  service.setSecondFactor = setSecondFactor;

  // currently the user taken from the config
  function getProfileData() {
    return _.clone(appConfig.user);
  }

  // returns the user key and image for two factor authenticator
  function getTwoFactor() {
    return $sails.get('/auth/secondFactor')
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  // sends an email to authenticated user for resetting password
  function resetPassword(email) {
    return $sails.post('/auth/sendPassword', email)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  // this will eventually send the user data to the provided endpoint
  function saveProfile(profileData) {
    return $sails.put(`/user/${profileData.id}`, profileData)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  // this will eventually send the user data to the provided endpoint
  function updatePassword(passwordData) {
    return $sails.put(`/user/${passwordData.userId}`, passwordData)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  // Enable / Save two factor authenticator
  function setSecondFactor(data) {
    return $sails.post('/auth/secondFactor', data)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

}
